import { useContext } from 'react'
import { LoyaltyContext } from '../context/LoyaltyContext'

export const useLoyaltyContext = () => {
  const context = useContext(LoyaltyContext)
  if (!context) {
    throw new Error('useLoyaltyContext must be used within LoyaltyProvider')
  }
  return context
}
